import { ColumnConfig } from '../model';

export const bulkOrderListUploadConfig: Record<any, ColumnConfig> = {
  sNo: {
    name: 'S.no',
  },
  orderNo: {
    name: 'Order No.',
    field: 'NavigateLink',
  },
  orderedDate: { name: 'Ordered Date' },
  customerName: {
    name: 'Customer Name',
    // field: 'avatarNameStatus',
    field: 'component',
    isComponent: true,
  },
  //   status: {
  //     name: 'Status',
  //     field: 'Component',
  //   },
  skuCount: {
    name: 'SKU Count',
  },
  netOrderValue: {
    name: 'Net Order Value',
  },
  //   orderSavings: {
  //     name: 'Order Savings',
  //   },
  erpOrderNumber: {
    name: 'ERP Order Number',
    field: `erpOrderNumber`,
  },
  tags: {
    name: 'Tags',
  },
  taskStatus: {
    name: 'Task Status',
  },
};
